import { isEmbedded } from '@/config';
import useHandleContextureBar from '@/hooks/useHandleContextureBar';
import { isShowContextualBarSelector } from '@/redux/slice/appbar.slice';
import { useSelector } from 'react-redux';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

export default function useConfirmationNavigate() {
  const navigate = useNavigate();
  const isShowContextualBar = useSelector(isShowContextualBarSelector);
  const contextualBar = useHandleContextureBar();
  return (to: To, options?: NavigateOptions) => {
    if (isShowContextualBar && isEmbedded) {
      console.log('isShowContextualBar', isShowContextualBar);
      contextualBar.leaveConfirmation();
    } else {
      navigate(to, options);
    }
  };
}
